import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import { AuthService } from '../../services';
import { HttpErrorHandler, HandleError } from 'src/app/shared/services/http-error-handler.service';
import { SharedModule } from '../../modules/shared/shared.module';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from '../../services/genericCustomStore.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
  currentIndex = 0;
  imgarray = ['assets/icons/erpp.png', 'assets/EPR_Pub_lowres_10.7.24.jpg', 'assets/icons/hand-drawn-flat-design-erp-illustration_23-2149365029.jpg', 'assets/icons/understanding-how-ERP-system-works-1024x597.webp']
  loading = false;
  formData: any = {};
  private handleError: HandleError;
  ImageUrl: any;
  hasBackground: boolean;
  constructor(private authService: AuthService, private router: Router, httpErrorHandler: HttpErrorHandler, public translate: TranslateService, public gt: genericCustomStoreService) {
    this.handleError = httpErrorHandler.createHandleError('LoginService');
  }

  // ngOnInit() {
  //    if (sessionStorage.getItem('token') != null && window.sessionStorage.getItem('data'))
  //      this.router.navigateByUrl('/home');       
  //  }

  logoUrl: string = "assets/icons/logo-removebg-preview.png";
  ngOnInit() {
    const token = sessionStorage.getItem('token');
    const data = sessionStorage.getItem('data');
    if (token && data) {
      this.router.navigate(['/home']);
    }

    this.sliderImg()
    if(environment.apiRoot.includes("cdcbak")) {
          this.logoUrl = "assets/icons/cdcLogo.png"
        }
  }


  async onSubmit(e: Event) {
    e.preventDefault();
    this.loading = true;
    const result = await this.authService.logIn(this.formData)
    if (!result.isOk) {
      this.loading = false;
      return;
    }
  }

  onCreateAccountClick = () => {
    this.router.navigate(['/create-account']);
  }


nextImage() {
  this.currentIndex = (this.currentIndex + 1) % this.imgarray.length;
}
  sliderImg(){
  setInterval(() => {
    this.nextImage();
  }, 3000);
  }
}



@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule,
    SharedModule
  ],
  declarations: [LoginFormComponent],
  exports: [LoginFormComponent]
})
export class LoginFormModule { }
